<template>
	<v-container>
		<form>
			<!-- order date -->
			<v-row>
				<!-- Order Date Pickers -->
				<v-col cols="12" md="6" v-show="dateFromVisible">
					<v-menu
						ref="menuFrom"
						v-model="menuFrom"
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						max-width="290px"
						min-width="290px"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								v-model="formState.dateFromTemp"
								:rules="[rules.dateFormat]"
								label="Date from"
								v-bind="attrs"
								v-on="on"
							></v-text-field>
						</template>
						<v-date-picker
							v-model="formState.dateFromFinal"
							no-title
							@input="menuFrom = false"
							:first-day-of-week="1"
							:allowed-dates="allowedDates"
						></v-date-picker>
					</v-menu>
				</v-col>

				<v-col cols="12" md="6" v-show="dateTillVisible">
					<v-menu
						ref="menuTill"
						v-model="menuTill"
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						min-width="290px"
					>
						<template v-slot:activator="{ on }">
							<v-text-field
								v-model="formState.dateTillTemp"
								:rules="[rules.dateFormatTill]"
								label="Date till"
								v-on="on"
							></v-text-field>
						</template>
						<v-date-picker
							v-model="formState.dateTillFinal"
							no-title
							@input="menuTill = false"
							:first-day-of-week="1"
							:allowed-dates="allowedDates"
						></v-date-picker>
					</v-menu>
				</v-col>
			</v-row>

			<!-- Product and order state-->
			<v-row>
				<v-col cols="12" md="6">
					<v-autocomplete
						v-model="formState.selectedProducts"
						:items="formItems.products"
						:search-input.sync="searchProducts"
						hide-selected
						label="Product SKU"
						multiple
						persistent-hint
						chips
						return-object
					/>
				</v-col>
				<v-col cols="12" md="6">
					<v-autocomplete
						v-model="formState.selectedStates"
						:items="formItems.states"
						hide-selected
						label="Order State"
						multiple
						persistent-hint
						chips
						return-object
					/>
				</v-col>
			</v-row>

			<v-btn
				class="searchButton ml-5"
				color="primary"
				@click="submitData"
			> {{ txt.showData }}
			</v-btn>

			<v-btn
				class="searchButton ml-5"
				@click="submitExcel"
			> {{ txt.excelExport }}
			</v-btn>
		</form>
	</v-container>
</template>

<script>
import axios from 'axios'

export default {
	name: 'blsSeepassFilter',
	data() {
		return {
			txt: {
				showData: 'Show Data',
				excelExport: 'Excel Export',
			},
			appNameShort: 'blsseepass',
			formItems: {
				products: [],
				states: [],
			},
			formState: {
				dateFromTemp: new Date().toISOString().substr(0, 10),
				dateFromFinal: new Date().toISOString().substr(0, 10),
				dateTillTemp: new Date().toISOString().substr(0, 10),
				dateTillFinal: new Date().toISOString().substr(0, 10),
				selectedProducts: [],
				selectedStates: [],
			},
			rules: {
				dateFormat: () => this.dateFromCorrect || 'Date is not valid. YYYY-MM-DD',
				dateFormatTill: () => this.dateTillCorrect || 'Date is not valid. YYYY-MM-DD',
			},

			dateFromVisible: true,
			dateTillVisible: true,
			menuFrom: false,
			menuTill: false,

			searchProducts: null,
		}
	},
	watch: {
		'formState.dateFromTemp': {
			handler() {
				this.parseDate(this.formState.dateFromTemp)
			},
		},
		'formState.dateFromFinal': {
			handler() {
				this.setDateAsFinal(this.formState.dateFromFinal)
			},
		},
		'formState.dateTillTemp': {
			handler() {
				this.parseTillDate(this.formState.dateTillTemp)
			},
		},
		'formState.dateTillFinal': {
			handler() {
				this.setTillDateLikePicker(this.formState.dateTillFinal)
			},
		},
	},
	methods: {
		allowedDates(val) {
			const d1 = new Date(val)
			const d2 = new Date()
			return d1 < d2
		},
		parseDate(date) {
			const dateSplitted = date.split('-')
			if (
				dateSplitted.length === 3
				&& dateSplitted[0].length === 4
				&& dateSplitted[1].length === 2
				&& dateSplitted[2].length === 2
				&& date.length === 10
			) {
				const dateParsable = date.split('-').join('/')
				const dateISOString = new Date(dateParsable)
				// eslint-disable-next-line eqeqeq
				if (dateISOString != 'Invalid Date') {
					this.formState.dateFromFinal = `${dateSplitted[0]}-${dateSplitted[1]}-${dateSplitted[2]}`
					this.formState.dateFromTemp = `${dateSplitted[0]}-${dateSplitted[1]}-${dateSplitted[2]}`
					this.dateFromCorrect = true
					this.menuFrom = false
					return true
				}
			}
			this.dateFromCorrect = false
			return false
		},
		parseTillDate(date) {
			const dateSplitted = date.split('-')
			if (
				dateSplitted.length == 3
				&& dateSplitted[0].length == 4
				&& dateSplitted[1].length == 2
				&& dateSplitted[2].length == 2
				&& date.length == 10
			) {
				const dateParsable = date.split('-').join('/')
				const dateISOString = new Date(dateParsable)
				if (dateISOString != 'Invalid Date') {
					this.formState.dateTillFinal = `${dateSplitted[0]}-${dateSplitted[1]}-${dateSplitted[2]}`
					this.formState.dateTillTemp = `${dateSplitted[0]}-${dateSplitted[1]}-${dateSplitted[2]}`
					this.dateTillCorrect = true
					this.menuTill = false
					return true
				}
			}
			this.dateTillCorrect = false
			return false
		},
		setDateAsFinal(dateInDatePicker) {
			this.formState.dateFromTemp = dateInDatePicker
		},
		setTillDateLikePicker(dateInDatePicker) {
			this.formState.dateTillTemp = dateInDatePicker
		},
		async getProductSku() {
			try {
				const r = await axios.get(`${config.baseAPIurl}/bls-seepass-report/product`)
				this.formItems.products = r.data
				if (r.data.length <= 0) this.formItems.products.push('No data.')
			} catch (e) {
				console.log(e)
			}
		},
		async getOrderStates() {
			try {
				const r = await axios.get(`${config.baseAPIurl}/bls-seepass-report/order-state`)
				this.formItems.states = r.data
				if (r.data.length <= 0) this.formItems.states.push('No data.')
			} catch (e) {
				console.log(e)
			}
		},
		submitData() {
			const request = {
				dateFrom: this.formState.dateFromFinal,
				dateTill: this.formState.dateTillFinal,
				selectedProducts: this.formState.selectedProducts,
				selectedOrderStates: this.formState.selectedStates,
			}
			this.$emit('submit', request)
		},
		submitExcel() {
			const request = {
				dateFrom: this.formState.dateFromFinal,
				dateTill: this.formState.dateTillFinal,
				selectedProducts: this.formState.selectedProducts,
				selectedOrderStates: this.formState.selectedStates,
			}
			this.$emit('submitExcel', request)
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.getProductSku()
			this.getOrderStates()
		})
	},
}
</script>

<style scoped>

.filterContainer {
	padding: 0px !important;
}

</style>
